// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wm6fgh","small":"nK0LnP","medium":"_4OKzxS","large":"sdUpfr","isFull":"Ra2Q4w","vertical":"lZazXs","horizontal":"VRVxJp","center":"WCMw9p"};